import { Component,HostListener} from "@angular/core";
import { MenuService } from "./app.menu.service";
import { PrimeNGConfig } from "primeng/api";
import { AppComponent } from "./app.component";
import { Router,NavigationEnd } from "@angular/router";
import { filter } from 'rxjs/operators';
import { AuthData } from "./core/data";

@Component({
    selector: "app-main",
    templateUrl: "./app.main.component.html",
    styleUrls: ["./app.main.component.scss"],
    standalone: false
})
export class AppMainComponent {
    overlayMenuActive: boolean;
    staticMenuDesktopInactive = false;
    staticMenuMobileActive: boolean;
    sidebarActive = false;
    sidebarStatic = false;
    menuClick: boolean;
    menuHoverActive = false;
    topbarMenuActive: boolean;
    topbarItemClick: boolean;
    activeTopbarItem: any;
    configActive: boolean;
    configClick: boolean;
    rightMenuActive: boolean;
    rightMenuClick: boolean;
    searchActive: boolean;
    searchClick: boolean;
    activeInlineProfile: boolean;
    pinActive: boolean;
    togglesidebar = false;
    currentRoute: string = '';
    
    constructor(
        private menuService: MenuService,
        private primengConfig: PrimeNGConfig,
        public app: AppComponent,
        private router: Router,
        private authApiservice: AuthData
    ) {
        let role = this.authApiservice.getRole()
        const currentUrl = this.router.url;
        
        if (role == "CMS") {
            if (!currentUrl.startsWith('/admin')) {
                this.router.navigate(['/admin/my-tickets'])
            }
        }else  if (role == "TMS") {
            if (!currentUrl.startsWith('/admin')) {
                this.router.navigate(['/admin/order-fulfilment'])
            }
        }else if (role == "Sales Agent") {
            if (!currentUrl.startsWith('/sales-agent')) {
                this.router.navigate(['/sales-agent/'])
            }
        }
        else if (role == "Enterprise Sim") {
            // Only redirect to dashboard if not already on an enterprise-sim route
            if (!currentUrl.startsWith('/enterprise-sim')) {
                this.router.navigate(['/enterprise-sim/dashboard'])
            }
        }
    }
    /***************************************************/
    /***************************************************/
    /***************************************************/
    ngOnInit() {
        // Subscribe to NavigationEnd to detect when the route changes
        this.router.events
          .pipe(filter(event => event instanceof NavigationEnd))
          .subscribe((event: NavigationEnd) => {
            this.togglesidebar = false;
          });
      }
    handleSidebarToggle() {
        this.togglesidebar = !this.togglesidebar;
    }
    // Listen for window resize events
    @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
        const width = (event.target as Window).innerWidth;
        if(width>1200){
            this.togglesidebar = false;
        }
        //this.handleSidebar(width);
    }
    // private checkScreenSize(width: number) {
    //     this.isSmallScreen = width < 768; // Example: Small screen if width is less than 768px
    // }
    /***************************************************/
    /***************************************************/
    /***************************************************/
    onLayoutClick() {


        if (!this.topbarItemClick) {
            this.activeTopbarItem = null;
            this.topbarMenuActive = false;
        }

        if (this.configActive && !this.configClick) {
            this.configActive = false;
        }

        if (this.rightMenuActive && !this.rightMenuClick) {
            this.rightMenuActive = false;
        }

        if (this.searchActive && !this.searchClick) {
            this.searchActive = false;
        }

        if (!this.menuClick) {
            if ((this.isSlim() || this.isHorizontal()) && !this.isMobile()) {
                this.menuService.reset();
                this.menuHoverActive = false;
            }

            if (this.overlayMenuActive || this.staticMenuMobileActive) {
                this.overlayMenuActive = false;
                this.staticMenuMobileActive = false;
            }
        }

        this.configClick = false;
        this.rightMenuClick = false;
        this.searchClick = false;
        this.menuClick = false;
        this.topbarItemClick = false;
    }

    onSidebarClick($event) {
        this.menuClick = true;
    }

    onToggleMenu(event) {
        this.menuClick = true;

        if (this.overlayMenuActive) {
            this.overlayMenuActive = false;
        }

        if (this.sidebarActive) {
            this.sidebarStatic = !this.sidebarStatic;
        }

        event.preventDefault();
    }

    onSidebarMouseOver(event) {
        if (this.app.menuMode === "sidebar" && !this.sidebarStatic) {
            this.sidebarActive = this.isDesktop();
            setTimeout(() => {
                this.pinActive = this.isDesktop();
            }, 200);
        }
    }

    onSidebarMouseLeave($event) {
        if (this.app.menuMode === "sidebar" && !this.sidebarStatic) {
            setTimeout(() => {
                this.sidebarActive = false;
                this.pinActive = false;
            }, 250);
        }
    }

    onMenuButtonClick(event) {
        this.menuClick = true;

        if (this.isOverlay()) {
            this.overlayMenuActive = !this.overlayMenuActive;
        }

        if (this.isDesktop()) {
            this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
        } else {
            this.staticMenuMobileActive = !this.staticMenuMobileActive;
        }

        event.preventDefault();
    }

    onTopbarItemClick(event, item) {
        ;
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        event.preventDefault();
    }

    onTopbarSubItemClick(event) {
        event.preventDefault();
    }

    onRippleChange(event) {
        this.app.ripple = event.checked;
        this.primengConfig.ripple = event.checked;
    }

    onConfigClick(event) {
        this.configClick = true;
    }

    onRightMenuButtonClick() {
        this.rightMenuClick = true;
        this.rightMenuActive = true;
    }

    onRightMenuClick($event) {
        this.rightMenuClick = true;
    }

    isStatic() {
        return this.app.menuMode === "static";
    }

    isOverlay() {
        return this.app.menuMode === "overlay";
    }

    isSlim() {
        return this.app.menuMode === "slim";
    }

    isHorizontal() {
        return this.app.menuMode === "horizontal";
    }

    isSidebar() {
        return this.app.menuMode === "sidebar";
    }

    isDesktop() {
        return window.innerWidth > 991;
    }

    isMobile() {
        return window.innerWidth <= 991;
    }

    logout() {
        this.authApiservice.logOut();
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        
        if (!this.topbarItemClick) {
            this.activeTopbarItem = null;
          }
          // reset for next click
          this.topbarItemClick = false;
    }
}
